import React, { useEffect, useMemo, useState } from 'react';
import { TabLayout } from 'src/@vymo/ui/blocks';
import { getDetails } from 'src/models/details/selectors';
import { useAppSelector } from 'src/store/hooks';
import { getDetailTabs } from './queries';
import styles from '../index.module.scss';

function DetailsBody(props) {
  const { entityId } = props;
  const details = useAppSelector((state) => getDetails(state, entityId));
  const tabConfig = useMemo(
    () => getDetailTabs(props, details),
    [props, details],
  );
  const [selectedTab, setSelectedTab] = useState<string>(
    tabConfig?.[0]?.key || '',
  );

  useEffect(() => {
    setSelectedTab(tabConfig?.[0]?.key || '');
  }, [tabConfig]);

  return (
    <div className={styles.detailsWrapper__detailsBody}>
      <TabLayout
        classNames={styles.detailsWrapper__detailsBody__tab}
        items={tabConfig}
        defaultKey={selectedTab}
        onChange={(key) => setSelectedTab(key)}
      />
    </div>
  );
}

export default DetailsBody;
